export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

export function isGoogleAuthEnabled() {
  return Boolean(GOOGLE_CLIENT_ID);
}

export function mapGoogleAuthError(code, t) {
  if (code === 'no_internet') return t.errorNoInternet;
  if (code === 'user_exist') return t.errorUserExist;
  if (code === 'google_auth_failed') return t.errorGoogleAuth;
  return code || t.errorGoogleAuth;
}
